// React
import { useEffect, useState } from 'react'

// Material-UI
import { Grid } from '@material-ui/core'

// Components
import MyAccordionCtrl from '../../../../control/accordion/accordion'
import PreviewUploadFile from './uploadFile/PreviewUploadFile'

// Hooks
import useTranslate from '../../../../i18n/useTranslate'
import useLookupService from '../../../../services/lookup/useLookupService'

// Types
import type { GetProjectResultType as Project } from '../../../../services/web/types/responseWebServiceTypes'
import type { ResultDocumentTopicLut as DocumentTopic } from '../../../../services/lookup/types/responseLookupServiceTypes'

import { topicForStudent, topicForLecturer } from '../../../../constants/constants'
export interface PreviewUploadDocProps {
    dataSource: Project
}

const PreviewUploadDoc = (props: PreviewUploadDocProps) => {
    const { dataSource } = props
    const { callPublicDocumentTopicLut } = useLookupService()
    const translate = useTranslate()

    const [documentTopics, setDocumentTopics] = useState<DocumentTopic[]>([])

    const getDocumentInfo = (topicId: number) => {
        return dataSource.documentInfo.find((e) => e.topicID === topicId)
    }

    useEffect(() => {
        if (!dataSource.irb || !dataSource.submitTypeInfo.value) return

        // * The logic is base on function filterTopicUpload in other flow
        const filterDocumentTopics = (docTopics: DocumentTopic[]): DocumentTopic[] => {
            let filteredDocumentTopics: DocumentTopic[] = []
            const researcherTypeID = dataSource.researcherTypeInfo.value
            const topicConstant = researcherTypeID === 1 ? topicForLecturer : topicForStudent
            topicConstant.forEach((e) => {
                filteredDocumentTopics = docTopics
                    .filter((d) => d.id !== e.id)
                    .map((d, index) => ({ ...d, no: index + 1 }))
            })
            return filteredDocumentTopics
        }

        const fetchDocumentTopics = async () => {
            try {
                const { result, status, message } = await callPublicDocumentTopicLut(
                    dataSource.irb,
                    dataSource.submitTypeInfo.value,
                )

                if (status !== 1) {
                    throw new Error(`fetched document topic error with status: ${status} ${message}`)
                }
                const filteredDocumentTopics = filterDocumentTopics(result ?? [])
                setDocumentTopics(filteredDocumentTopics)
            } catch (error) {
                console.error('has an error while fetching document topic: ', error)
            }
        }

        fetchDocumentTopics()
    }, [dataSource.irb, dataSource.submitTypeInfo.value])

    return (
        <MyAccordionCtrl title={translate.get('LABEL.UPLOAD_FILES')}>
            <Grid container spacing={2}>
                {documentTopics.map((e, index) => (
                    <Grid container item xs={12} key={e.id}>
                        <PreviewUploadFile no={index + 1} documentTopic={e} documentInfo={getDocumentInfo(e.id)} />
                    </Grid>
                ))}
            </Grid>
        </MyAccordionCtrl>
    )
}

export default PreviewUploadDoc
